
export default {
  name: 'vendor-resources-group',
  props: {
    signedInUser: Object,
    forceRootViewRefresh: Function
  }
}
